// Turn a product name into a URL-friendly slug, appending the id for uniqueness.
// e.g. slugify("Cool Widget!", 42) -> "cool-widget-42"
export const slugify = (name, id) => {
  const base = String(name || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip accents
    .replace(/đ/g, "d")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
  return base ? `${base}-${id}` : String(id);
};

// Extract the trailing numeric id from a slug. "cool-widget-42" -> 42
export const idFromSlug = (slug) => {
  const m = String(slug || "").match(/(\d+)$/);
  return m ? parseInt(m[1], 10) : null;
};

// Build the full product detail path.
export const productPath = (product) =>
  `/product/${slugify(product.name, product.id)}`;
